import { getBusiness } from 'lib/api';
import CenteredCircularProgress from 'lib/designSystem/CircularProgress';
import EnhancedTab from 'lib/designSystem/TabSimulation';
import { showAlert, validatePermissions } from 'lib/functions/utils';
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate, useParams } from 'react-router-dom';

import { AuthState } from '../../../services/redux/authSlice';
import BankAccounts from './components/BankAccounts';
import Client from './components/Client';
import ProfileCompliance from './components/Compliance';
import Contacts from './components/Contacts';
import Files from './components/Files';
import OperativeProfile from './components/Operative';

const Profile = () => {
  const { id, page } = useParams<{
    id: string;
    businessId: string;
    page: string;
  }>();
  const currentPath = window.location.pathname;
  const initialPath = currentPath.split('/')[2];
  const temporary = initialPath === 'temporary';
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(true);
  const [business, setBusiness] = useState({ name: '', companies: [] });
  const [companyTabs, setCompanyTabs] = useState<any>([]);
  const navigate = useNavigate();
  const user = useSelector((state: { auth: AuthState }) => state.auth.user);
  const [startValue, setStartValue] = useState(0);
  const handleNavigation = (index: number) => {
    navigate(`/companies/${id}/profile/${companyTabs[index].path}`);
  };

  const handleNavigationTemporary = (index: number) => {
    navigate(`/companies/temporary/${id}/profile/${companyTabs[index].path}`);
  };

  const mainBusiness = async () => {
    if (!id) {
      setLoading(false);
      return alert('Ha ocurrido un error');
    }
    const business = await getBusiness(dispatch, id);
    const newProfileTabs: any = [...tabs];
    let startValueDefault = 0;
    startValueDefault = newProfileTabs.findIndex((x: any) => x.path === page);
    setCompanyTabs(newProfileTabs);
    setStartValue(startValueDefault === -1 ? 0 : startValueDefault);
    setBusiness(business);
  };

  const tabs = [
    {
      id: 1,
      label: 'Resumen',
      component: <Client />,
      path: 'summary',
    },
    ...(validatePermissions(user, 'business_can_view_files')
      ? [
          {
            id: 2,
            label: 'Archivos',
            component: <Files businessIdentifier={id} />,
            path: 'files',
          },
        ]
      : []),
    {
      id: 3,
      label: 'Contactos',
      component: <Contacts />,
      path: 'contacts',
    },
    {
      id: 4,
      label: 'Banco',
      component: <BankAccounts />,
      path: 'bankAccounts',
    },
    {
      id: 5,
      label: 'Operativo',
      component: <OperativeProfile businessIdentifier={id ?? ''} />,
      path: 'operative',
    },
    ...(validatePermissions(user, 'business_can_view_compliance_files')
      ? [
          {
            id: 6,
            label: 'Compliance',
            component: <ProfileCompliance />,
            path: 'compliance',
          },
        ]
      : []),
  ];

  const setUp = async () => {
    setLoading(true);
    try {
      if (!id) {
        return setLoading(false);
      }
      await mainBusiness();
    } catch (error) {
      showAlert(dispatch, 'error', 'Ha ocurrido un error');
    }
    setLoading(false);
  };

  useEffect(() => {
    setUp();
  }, []);
  if (loading) return <CenteredCircularProgress />;

  return (
    <div>
      <EnhancedTab
        tabType="secondary"
        startValue={startValue}
        title={temporary ? business.name : undefined}
        tabs={companyTabs}
        onTabChange={!temporary ? handleNavigation : handleNavigationTemporary}
        // canShowTab={checkCanAccessView()}
      />
    </div>
  );
};

export default Profile;
